exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#reset{\r\nmargin-left:78%;\t\r\n}\r\n::ng-deep .mat-progress-bar-fill::after {\r\n    background-color: #F15D22;\r\n}\r\n\r\n::ng-deep .mat-progress-bar-buffer {\r\n    background: #E4E8EB;\r\n}\r\n\r\n::ng-deep .mat-progress-bar {\r\n    border-radius: 2px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-users/change-password/change-password.component.css
// module id = 460
// module chunks = 1